<script>
import AppModal from '@/components/AppModal.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    AppModal,
    InputSelect
  },
  data () {
    return {
      responsaveis: [],
      responsavel: null
    }
  },
  created () {
    this.getResponsaveis()
  },
  methods: {
    ...mapActions({
      findResponsaveisBySetorLogado: 'usuario/findResponsaveisBySetorLogado'
    }),
    closeModal () {
      this.$emit('closeModal')
    },
    alterar () {
      this.$emit('alterar', this.responsavel)
    },
    async getResponsaveis () {
      const responsaveis = await this.findResponsaveisBySetorLogado()
      this.responsaveis = responsaveis.map(responsavel => ({id: responsavel.id, nome: `${responsavel.nomeRazaoSocial} (${responsavel.perfil.nome})`}))
    }
  }
}
</script>

<template>
  <app-modal
    titulo="Vincular/Trocar Responsável"
    :closeOutside="true"
    @closeModal="closeModal"
    :hasFooter="true"
    :width="600"
  >
    <template slot="body">
      <InputSelect
        label="Responsável:" v-model="responsavel"
        :opcoes="responsaveis"
      />
    </template>
    <template slot="footer">
      <div class="flex-end">
        <el-button type="primary" @click="alterar">Alterar</el-button>
      </div>
    </template>
  </app-modal>
</template>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/TrocarResponsavel/TrocarResponsavel.vue